import deliverClubIcon from '@images/delivery_icon.png'
import devicesIcon from '@images/devices_icon.png'
import domclickIcon from '@images/domclick.png'
import logisticsIcon from '@images/logisticks.png'
import okkoIcon from '@images/okko_icon.png'
import prymeIcon from '@images/pryme_icon.png'
import sberIcon from '@images/sber_icon.png'
import sbermarketIcon from '@images/sbermarket_icon.png'
import sbermobileIcon from '@images/sbermobile.png'
import sberstrakhIcon from '@images/sberstrakh.png'
import spasiboIcon from '@images/spasibo.png'
import zvukIcon from '@images/zvuk.png'
import { IItem } from './Item/types'

export const services: Array<IItem> = [
  {
    src: sberIcon,
    href: 'http://sberbank.ru/',
    text: 'Сбербанк',
    alt: 'sber-icon',
  },
  {
    src: prymeIcon,
    href: 'https://sber.ru/sberprime',
    text: 'СберПрайм',
    alt: 'sber-prime-icon',
  },
  {
    src: sbermarketIcon,
    href: 'https://sbermarket.ru/',
    text: 'СберМаркет',
    alt: 'sber-market-icon',
  },
  {
    src: okkoIcon,
    href: 'https://okko.tv/',
    text: 'Окко',
    alt: 'okko-icon',
  },
  {
    src: domclickIcon,
    href: 'https://domclick.ru/',
    text: 'Домклик',
    alt: 'domclick-icon',
  },
  {
    src: spasiboIcon,
    href: 'https://spasibosberbank.ru/',
    text: 'Спасибо',
    alt: 'spasibo-icon',
  },
  {
    src: sberstrakhIcon,
    href: 'https://www.sberbank-insurance.ru/',
    text: 'СберСтрахование',
    alt: 'sber-insurance-icon',
  },
  {
    src: sbermobileIcon,
    href: 'https://sbermobile.ru/',
    text: 'СберМобайл',
    alt: 'sber-mobile-icon',
  },
  {
    src: logisticsIcon,
    href: 'https://sblogistica.ru/',
    text: 'СберЛогистика',
    alt: 'sber-logistica-icon',
  },
  {
    src: deliverClubIcon,
    href: 'https://www.delivery-club.ru/',
    text: 'Delivery Club',
    alt: 'delivery-club-icon',
  },
  {
    src: zvukIcon,
    href: 'https://zvk.onelink.me/dd8d/f429c97e',
    text: 'СберЗвук',
    alt: 'sber-zvk-icon',
  },
  {
    src: devicesIcon,
    href: 'https://sber.ru/salute',
    text: 'СберДевайсы',
    alt: 'sber-device-icon',
  },
]
